import PropTypes from "prop-types";
import React from "react"
import "./statusbar.css";
const statusArray = [
  "created",
  "accepted",
  "completedPending",
  "completed",
  "declined",
  "cancelled",
];

const progressStatusArray = [
  "created",
  "accepted",
  "completedPending",
  "completed",
];

const updatingStatusArray = (progressStatusArray) => {
  const newArr = [];
  for (let i = 0; i < progressStatusArray.length; i++) {
    newArr.push(progressStatusArray[i], "");
  }

  newArr.pop();
  return newArr;
};

const getStatusIcon = (status) => {
  switch (status) {
    case "created":
      return "/static/images/transactions/created.png";
    case "completed":
      return "/static/images/transactions/completed.png";
    case "accepted":
      return "/static/images/transactions/accepted.png";
    case "declined":
      return "/static/images/transactions/declined.png";
    case "cancelled":
      return "/static/images/transactions/declined.png";
    case "completedPending":
      return "/static/images/transactions/completedPending.png";
    default:
      return "";
  }
};

const StatusBar = ({ status }) => {
  const generatingStatuses = (status) => {
    if (status === "declined" || status === "cancelled") {
      return (
        <img
          src={getStatusIcon(status)}
          alt="created"
          className="sb__icon sb__icon--declined"
        />
      );
    }

    const index = updatingStatusArray(progressStatusArray).findIndex(
      (item) => item === status
    );

    return updatingStatusArray(progressStatusArray).map((item, i) => {
      if (item === "") {
        return (
          <div
            key={item + i}
            className={`sb__line mx-2 flex-grow-1 ${
              i <= index ? "sb__line--active" : ""
            }`}
          ></div>
        );
      } else {
        return (
          <img
            key={item + i}
            src={getStatusIcon(item)}
            alt="created"
            className={`sb__icon mx-1 ${i <= index ? "sb__icon--active" : ""}`}
          />
        );
      }
    });
  };

  return (
    <div className="status-bar">
      <div className="sb__container">
        <div className="sb d-flex align-items-center justify-content-center">
          {generatingStatuses(status)}
        </div>
      </div>
    </div>
  );
};

export default StatusBar;


// WEBPACK FOOTER //
// ./client/react/Admin/views/TransactionDetail/statusbar.js